<div class="container pt-lg-5 px-lg-0 pt-4">
	<div class="my-5">
		<div class="row d-lg-none align-items-end mt-4">
			<div class="col-6 col-md-4">
				<div class="mt-3 d-flex">
					<div class="row no-gutters">
						<div class="col">
							<input class="form-bertazzoni white border-right-0 rounded-0" type="SEARCH" value="SEARCH" id="" />
						</div>
						<div class="col-auto">
							<div class="border-left-0 rounded-0 rounded-right form-bertazzoni-search">
								<i class="icon-search font-16"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-6 col-md-2">
				<div class="mt-3 d-flex">
					<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" style="height: 35px;">SEARCH</button>
				</div>
			</div>
		</div>
		<div class="row mt-5 mt-lg-0">
			<div class="col-12">
				<div class="text-center">
					<h1 class="titolo-bertazzoni">
						2
						<span class=" font-weight-light">results for:</span>
						{{query}}
					</h1>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-6 col-lg-4 mb-4 card-category zoom">
				<div class="row card-category-img">
					<div class="col-md-10 col-12 text-center">
						<img [routerLink]="" src="../../../assets/media/products/detail-forno.png" />
					</div>
					<div class="col-md-2 col-8 mt-5 mx-auto d-flex d-md-block text-right justify-content-around align-items-center">
						<div class="cerchietto-2 my-2"></div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 mt-4 px-4">
						<p class="text-secondary mb-0">codice commerciale</p>
						<p class="font-16 mb-0 font-semibold">nome del prodotto</p>
						<p class="mb-0">Linea estetica</p>
					</div>
				</div>
				<div class="row">
					<div class="col-12 mt-4">
						<div class="bg-grey-my py-3 text-center">
							<p class="mb-0 font-20 text-white">{{ '' | valuta }} 8268</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
